<button
  class="bg-primary text-on-primary disabled:bg-theme-gray-500 pointer-events-auto flex w-fit cursor-pointer items-center justify-center gap-1.5 rounded-md px-2 py-1 disabled:cursor-crosshair"
  (click)="buttonClicked.emit(); $event.stopPropagation()"
  (mouseup)="$event.stopPropagation()"
  (mousedown)="$event.preventDefault(); $event.stopPropagation()">
  <span class="material-icons flex !h-fit !w-fit text-sm">arrow_back</span>
  <span class="block h-fit w-fit text-[0.6rem] uppercase">Zurück</span>
</button>
